import React, { useEffect, useState } from "react";
import firebase from "../../config/firebase";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import PaymentConditionList from "./PaymentConditionList";
import ModernAlertDialog from "../frete/components/ModernAlertDialog";

function PaymentConditionPage() {
  const db = firebase.firestore();

  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogTitle, setInfoDialogTitle] = useState("");
  const [infoDialogMsg, setInfoDialogMsg] = useState("");

  useEffect(() => {
    const unsubscribe = db
      .collection("paymentCondition")
      .orderBy("description")
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setConditions(data);
          setLoading(false);
        },
        (error) => {
          console.error("Erro ao buscar condicoes de pagamento:", error);
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, []);

  const handleOpenDelete = (condition) => {
    setSelectedCondition(condition);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedCondition?.id) return;

    try {
      await db.collection("paymentCondition").doc(selectedCondition.id).delete();
      setInfoDialogTitle("Exclusao concluida");
      setInfoDialogMsg("Condicao de pagamento excluida com sucesso.");
      setOpenInfoDialog(true);
    } catch (error) {
      console.error(error);
      setInfoDialogTitle("Erro ao excluir");
      setInfoDialogMsg("Nao foi possivel excluir a condicao de pagamento.");
      setOpenInfoDialog(true);
    } finally {
      setOpenDeleteDialog(false);
      setSelectedCondition(null);
    }
  };

  return (
    <NewMiniDrawer
      divOpen={
        <>
          <PaymentConditionList
            conditions={conditions}
            loading={loading}
            openDeleteModal={handleOpenDelete}
          />

          <ModernAlertDialog
            open={openDeleteDialog}
            handleClose={() => setOpenDeleteDialog(false)}
            title="Confirmar exclusao"
            msg={`Deseja excluir a condicao \"${selectedCondition?.description || ""}\"?`}
            showCancel
            confirmLabel="Excluir"
            cancelLabel="Cancelar"
            onConfirm={handleDeleteConfirm}
            onCancel={() => setOpenDeleteDialog(false)}
          />

          <ModernAlertDialog
            open={openInfoDialog}
            handleClose={() => setOpenInfoDialog(false)}
            title={infoDialogTitle}
            msg={infoDialogMsg}
          />
        </>
      }
    />
  );
}

export default PaymentConditionPage;
